// extracted by mini-css-extract-plugin
export default {"root":"TextModeList_root__apdJI"};